
import { computed, watch, defineComponent, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import MagazineCardSlider from '@/components/block/MagazineCardSlider.vue'
import MagazineCardList from '@/components/block/MagazineCardList.vue'
import MagazineFooter from '@/components/block/MagazineFooter.vue'
import MagazineEventArchive from '@/components/block/MagazineEventArchive.vue'
import Pagination from '@/components/block/Pagination.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import { useRecommend } from '@/provider/recommend'
import { useSpecial } from '@/provider/special'
import { MagazineSpecialOutline } from '@/types/MagazineSpecial'

export default defineComponent({
  name: 'MagazinesKeyword',

  components: {
    MagazineCardList,
    MagazineCardSlider,
    MagazineFooter,
    MagazineEventArchive,
    HeadingLv1,
    HeadingLv3,
    Pagination
  },

  setup() {
    // レコメンド記事取得
    const { recommendState, loadRecommends } = useRecommend()
    loadRecommends()
    const recommends = computed(() => recommendState.allRecommends)

    const route = useRoute()
    const { state, loadContents, loadKeywords } = useSpecial()
    const loadKeywordContents = () => {
      loadContents({
        perPage: 10,
        keyword: route.params.id ? String(route.params.id) : undefined,
        page: route.query.page ? Number(route.query.page) : undefined
      })
    }
    watch(
      () => [route.params.id, route.query.page],
      (next, prev) => {
        if (JSON.stringify(next) === JSON.stringify(prev)) return
        loadKeywordContents()
        loadKeywords()
      },
      { immediate: true }
    )

    const totalPages = computed(() => state.totalPages)
    const outlines = computed((): MagazineSpecialOutline[] =>
      state.contents.map((content) => ({
        ...content,
        category: content.childCategories[0]?.name
      }))
    )

    const keyword = computed(() =>
      state.keywords.find((keyword) => keyword.name === String(route.params.id))
    )
    const title = computed((): string => keyword.value?.name ?? '')
    const pageTitle = computed((): string => `キーワード：${title.value}`)

    watch(
      () => [title.value],
      (next) => {
        nextTick(() => {
          document.title = `${next[0]} 一覧 | 連載 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】`
          const lastBread = document.querySelector('.breadCrumb_list li span')
          if (lastBread) {
            lastBread.innerHTML = next[0]
          }
        })
      },
      { immediate: true }
    )

    return {
      pageTitle,
      recommends,
      totalPages,
      outlines
    }
  }
})
